/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Lorem Ipsum generator. Create placeholder text by paragraphs, sentences or words for your designs and mockups. Copy with one click.`)
};

const es_li_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador gratuito de Lorem Ipsum. Crea texto de marcador por párrafos, oraciones o palabras para tus diseños y maquetas. Copia con un solo clic.`)
};

const de_li_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Lorem Ipsum Generator. Erstellen Sie Platzhaltertext nach Absätzen, Sätzen oder Wörtern für Ihre Designs und Mockups. Mit einem Klick kopieren.`)
};

const nl_li_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Lorem Ipsum-generator. Maak plaatsaanduidingstekst per alinea, zin of woord voor je ontwerpen en mockups. Kopieer met één klik.`)
};

const fr_li_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur Lorem Ipsum gratuit. Créez du texte de remplissage par paragraphes, phrases ou mots pour vos conceptions et maquettes. Copiez en un seul clic.`)
};

const it_li_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di Lorem Ipsum gratuito. Crea testo placeholder per paragrafi, frasi o parole per i tuoi design e mockup. Copia con un click.`)
};

const pt_br2_li_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Lorem Ipsum gratuito. Crie texto de espaço reservado por parágrafos, frases ou palavras para seus projetos e protótipos. Copie com um clique.`)
};

const pt_li_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador Lorem Ipsum gratuito. Crie texto espaço reservado por parágrafos, frases ou palavras para seus projetos e mockups. Copie com um clique.`)
};

const ja_li_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のLorem Ipsum生成器。段落、文、単語でプレースホルダーテキストを作成してデザインやモックアップに使用できます。ワンクリックでコピー可能です。`)
};

const zh_li_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的Lorem Ipsum生成器。按段落、句子或单词创建占位文本，用于你的设计和原型图。一键复制。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_tool_description", locale)
	if (locale === "en") return en_li_tool_description(inputs)
	if (locale === "es") return es_li_tool_description(inputs)
	if (locale === "de") return de_li_tool_description(inputs)
	if (locale === "nl") return nl_li_tool_description(inputs)
	if (locale === "fr") return fr_li_tool_description(inputs)
	if (locale === "it") return it_li_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_li_tool_description(inputs)
	if (locale === "pt") return pt_li_tool_description(inputs)
	if (locale === "ja") return ja_li_tool_description(inputs)
	return zh_li_tool_description(inputs)
};